import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'expansion-panel',
    templateUrl: 'expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.scss'],
    standalone: true,
    imports: [MatExpansionModule]
})
export class ExpansionPanelComponent {
    @Input() header: string;
    @Input() isExpanded = true;
}
